'use client';

import React from 'react';

type SalesRow = {
  product: string;
  bh: string;
  ebay: string;
  mpb: string;
  gearFocus: string;
};

type SalesTableSectionProps = {
  rows: SalesRow[];
  columns: {title: string, color?: string, bg?: string}[];
};

const SalesTableSection: React.FC<SalesTableSectionProps> = ({ rows, columns }) => {
  return (
    <section className="px-5 py-16 md:py-36">
      <div className="max-w-[1250px] mx-auto w-full">
        <h2 className="text-center text-[24px] md:text-[29px] font-normal mb-14">
          Are you more of a see-it-to-believe-it type of person? <br />
          Actual sales proceeds (including fees) as of Aug 2025:
        </h2>

        <div className="overflow-x-auto">
          <table className="min-w-full border-collapse text-sm md:text-base">
            <thead>
              <tr>
                <th className="border-0 px-4 py-8 text-left"> </th>
                {columns.map((column, index) => (
                  <th
                    key={index}
                    className="border border-[#A6A6A6] px-4 py-2 font-medium text-[20px] leading-[0px]"
                    style={{
                      backgroundColor: column.bg || undefined,
                      color: column.color || '#000',
                    }}
                  >
                    {column.title}
                  </th>
                ))}

              </tr>
            </thead>

            <tbody className="text-[14px] md:text-[18px] font-normal">
              {rows.map((row, index) => (
                <tr key={index}>
                  <td className="border border-[#A6A6A6] px-4 py-8 text-left text-nowrap">{row.product}</td>
                  <td className="border border-[#A6A6A6] px-4 py-8 text-center">{row.bh}</td>
                  <td className="border border-[#A6A6A6] px-4 py-8 text-center">{row.ebay}</td>
                  <td className="border border-[#A6A6A6] px-4 py-8 text-center">{row.mpb}</td>
                  <td className="border border-[#A6A6A6] px-4 py-8 text-center bg-[#F4F4F4]">{row.gearFocus}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
};

export default SalesTableSection;
